'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ProjectLayout} from '../../../components/views/ProjectLayout';
import {I18nMessage} from '../../../components/I18nMessage';
import {FeedList} from '../../../activity-feed/components/FeedList';
import {ASSET_TASK_COLLECTION, TASK_COLLECTION} from '../../domain/config';
import {isTaskType, TaskType} from '../../enums/TaskType';
import {TaskNavigationBar} from '../TaskNavigationBar';


export function TaskViewActivityView(props) {
  return (
    <ProjectLayout
      className={classNames("TaskViewActivity", props.className)}
      useScroll={false}
      title={<I18nMessage message="tasks.views.activity.title" />}
      showBackButton={true}
      onGoBack={props.onGoBack}
      breadcrumbPath={props.breadcrumbPath}
      filterComponent={null}
      navBarContent={(
        <TaskNavigationBar
          taskType={props.taskType}
          target={props.task}
        />
      )}
      bannerContent={null}
    >
      <FeedList
        className="ProjectLayout__scrollArea"
        scrollClassName="ProjectLayout__scroll"
        transitionGroupClass="ProjectLayout__content ProjectLayout__content__container"
        itemClassName="ProjectLayout__content__item"
        id={props.feedId}
        collection={props.taskType === TaskType.ASSET ? ASSET_TASK_COLLECTION : TASK_COLLECTION}
        init={props.init}
      />
    </ProjectLayout>
  );
}

TaskViewActivityView.propTypes = {
  className: T.string,
  taskType: isTaskType.isRequired,
  feedId: T.string.isRequired,

  init: T.bool,
};

TaskViewActivityView.defaultProps = {
  init: true,
};



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskViewActivity/TaskViewActivityView.js